const flexible_content_before = 
`<!-- Before refactor. Example of a service page-->

  <main id="main" class="site-main">
      <?php include dirname(__FILE__) . '/../includes/components/full-screen-hero.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/column-image-and-text.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/steps.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/meal-variety.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/meal-info.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/image-and-text-cta.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/comparison-table.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/trustpilot.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/flip-flop.php'; ?>
      <?php include dirname(__FILE__) . '/../includes/components/faq-section.php'; ?>
      <!-- . . . list of components -->
  </main>
`;

export default flexible_content_before;